import React from 'react';
import { Link as Rtlink } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { Link } from 'react-scroll';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
//import PhoneIcon from '@material-ui/icons/Phone';
import Typography from '@material-ui/core/Typography';

import { ReactComponent as Logo } from './imgs/logo.svg'; //IE対応。こうしないとSVGロゴが表示できない。
import { ReactComponent as LogoText } from './imgs/logotext.svg'; //IE対応。こうしないとSVGロゴが表示できない。

import MenuDrawer from './MenuDrawer';


const useStyles = makeStyles({
  appBar: {
    color: 'black',
    backgroundColor: 'rgba(250,250,250,0.9)',
  },

  logoText: {
    maxWidth:'250px',
    width:'auto', //IEではこれを指定しておかないとウィンドウを狭めたときに画像の縦横比が乱れる
    height:'auto', //IEではこれを指定しておかないとウィンドウを狭めたときに画像の縦横比が乱れる
  },

  wenoMain: {
    fontFamily: 'Noto Sans JP',
    fontSize: '17px',
    fontWeight: 500,
    color: 'black',
  },

  wenoSub: {
    fontFamily: 'Noto Sans JP',
    fontSize: '13px',
    fontWeight: 400,
    color: 'black',
    paddingLeft: '3px',
  },

  vAlign: {
    display: 'flex',
    justifyContent:'space-between', //IE対応かも
    alignItems: 'center', //IE対応かも
    height: '50px', //IE対応。これがないと上下中央揃えにならない。
  },

  links :{
    fontFamily:'Noto Sans JP',
    fontWeight: 500,
    fontSize:'14px',
    margin:'0% 0% 0% 0%',
  },

  phoneIcon: {
    display:'flex',
    alignItems:'center',
  },

  phoneNum: {
    fontFamily:'Noto Serif JP',
    fontWeight: 500,
    fontSize:'18px',
    margin:'0px 0px 0px 5px',
  },

  switchLang: {
    fontFamily: 'Noto Sans JP',
    fontWeight: 400,
    fontSize: '14px',
    color: '#3f51b5',
    whiteSpace: 'nowrap',
    textDecoration: 'underline',
  },
});

export default function OpaqueAppbar(props) {
  const classes = useStyles();
  const isMobile = useMediaQuery('(max-width: 900px)', {noSsr: true})

  return (
    <AppBar className={classes.appBar}>
      <Container style={{minWidth:'350px'}}>
        <Toolbar className={classes.vAlign} disableGutters={true}>

          <Logo style={{width:'11%', maxWidth:'40px'}} />

          {isMobile ?
            <div style={{display:'flex', flexDirection:'column', textAlign:'left', marginLeft:'2%'}}>
              <Typography className={classes.wenoSub} noWrap>弁理士法人</Typography>
              <Typography className={classes.wenoMain} noWrap>上野特許事務所</Typography>
            </div>
          :
            <div style={{display:'flex', flexDirection:'column', textAlign:'left', marginLeft:'2%'}}>
            <Typography className={classes.wenoMain} noWrap>弁理士法人上野特許事務所</Typography>
            <LogoText style={{height:'25px', maxWidth:'170px'}}/>
            </div>
          }

          <div style={{ flexGrow: 1 }}></div>

          {!isMobile &&
            <div style={{marginRight:"20px"}}>
              <Link to='pageTop' smooth={true} offset={-200}>
                <Button className={classes.links}>
                  理念
                </Button>
              </Link>

              <Link to='services' smooth={true} offset={-70}>
                <Button className={classes.links}> 
                  サービス
                </Button>
              </Link>

              <Link to='attoneies' smooth={true} offset={-70}>
                <Button className={classes.links}>
                  所属弁理士
                </Button>
              </Link>

              <Link to='profiles' smooth={true} offset={-70}>
                <Button className={classes.links}>
                  事務所概要
                </Button>
              </Link>

              <Link to='access' smooth={true} offset={-70}>
                <Button className={classes.links}>
                  アクセス
                </Button>
              </Link>
            </div>
          }

          <Rtlink to="/en">
            <Button style={{textTransform:'none'}}>
              <Typography className={classes.switchLang}>English</Typography>
            </Button>
          </Rtlink>

          {isMobile &&
            <MenuDrawer />
          }

          {/*
            <div className={classes.phoneIcon}>
              <PhoneIcon style={{fontSize:'large'}}/>
            </div>
            <div className={classes.phoneNum}>
              052-263-6871
            </div>
          */}

        </Toolbar>
      </Container>
    </AppBar>
  );
}